import { render, staticRenderFns } from "./VmTextField.vue?vue&type=template&id=5b972da2&scoped=true&"
import script from "./VmTextField.vue?vue&type=script&lang=js&"
export * from "./VmTextField.vue?vue&type=script&lang=js&"
import style0 from "./VmTextField.vue?vue&type=style&index=0&id=5b972da2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b972da2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
